const LEAD_TYPES = {
    ACCOUNT_CREATION: 87,
    APPOINTMENT_NEW: 23,
    APPOINTMENT_USED: 24,
    CONFIRMATION_NEW: 76,
    CONFIRMATION_USED: 66,
    DEPOSIT_NEW: 75,
    DEPOSIT_USED: 65,
    FACEBOOK_CONNECTION: 53,
    FINANCING_NEW: 77,
    FINANCING_USED: 67,
    INFORMATION_REQUEST: 38,
    TRADE_IN_NEW: 4,
    TRADE_IN_USED: 8,
};

export default LEAD_TYPES;
